export default __webpack_public_path__ + "static/media/IBMAddCommentRight.d627afe9.svg";